import React from 'react'
import PageLayout from './PageLayout'

const CopyrightPolicy = () => {
  return (
    <PageLayout>
      <div className="bg-white p-4 shadow-sm rounded">

        <h3>Copyright Policy</h3>
        <p className="text-muted">Last updated: {new Date().toDateString()}</p>
        <hr />

        <h5>1. Ownership</h5>
        <p>
          All content on Talent Club including UI, code, and branding is protected.
        </p>

        <h5>2. User Content</h5>
        <p>
          Users retain ownership but grant platform usage rights.
        </p>

        <h5>3. Restrictions</h5>
        <ul>
          <li>No copying without permission</li>
          <li>No commercial misuse</li>
          <li>No redistribution</li>
        </ul>

        <h5>4. Reporting Violations</h5>
        <p>
          Contact us if your content is misused.
        </p>

        <h5>5. Enforcement</h5>
        <p>
          Violations may result in account suspension or legal action.
        </p>

        <h5>6. Updates</h5>
        <p>
          Policy may change anytime.
        </p>

      </div>
    </PageLayout>
  )
}

export default CopyrightPolicy